/**
 * Footer Container Component
 */
import React, { Component } from 'react';
/* Import UI Components */
import { SetInnerHTML } from '../../../UI/SetInnerHTML/SetInnerHTML';
import QMSessionID from './QMSessionID';
import { PrivacyOptions } from '../../../../components/UI/Icons/Icons';

export class FooterContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.state.storedIsInternational = this.props.passedAppFunctions.isInternational();
    this.state.storedCountry = this.props.passedAppFunctions.country;
    this.state.storedCurrency = this.props.passedAppFunctions.currency;
  }

  liveChatOnClick() {
    window.openChatButtonClick();
  }

  emailSignUpSubmit() {
    window.emailValidation();
    return false;
  }

  cookieSettingsClick() {
    typeof Optanon !== 'undefined' && Optanon.ToggleInfoDisplay();
  }

  shouldComponentUpdate(nextProps, nextState) {
    var returnValue = false;
    if (!window._) {
      return true;
    }
    if (this.props.passedAppFunctions.isInternational() != this.state.storedIsInternational) {
      this.state.storedIsInternational = this.props.passedAppFunctions.isInternational();
      returnValue = true;
    }
    if (
      this.props.passedAppFunctions.country != this.state.storedCountry ||
      this.props.passedAppFunctions.currency != this.state.storedCurrency
    ) {
      this.state.storedCountry = this.props.passedAppFunctions.country;
      this.state.storedCurrency = this.props.passedAppFunctions.currency;
      returnValue = true;
    }
    return returnValue;
  }

  render() {
    return (
      <footer id='footer_wrapper'>
        <div id='footer' className='footer'>
          <div className='container-fluid'>
            <div className='row m-t-10 m-b-10 mx-0 footer-col'>
              <div className='col-md-3 col-sm-6  footer-content-section footer__contentSection'>
                <SetInnerHTML innerHTML={this.props.footerData.JSON.ES_Footer_1} espotname='ES_Footer_1' />
              </div>
              <div className='col-md-3 col-sm-6  footer-content-section footer__contentSection'>
                <SetInnerHTML innerHTML={this.props.footerData.JSON.ES_Footer_2} espotname='ES_Footer_2' />
              </div>
              <div className='col-md-3 col-sm-6  footer-content-section footer__contentSection'>
                <SetInnerHTML innerHTML={this.props.footerData.JSON.ES_Footer_3} espotname='ES_Footer_3' />
              </div>
              {!this.props.footerData.JSON.ES_Footer_4.indexOf('&nbsp') == 0 &&
              this.props.footerData.JSON.ES_Footer_4.length > 5 ? (
                <div className='col-md-3 col-sm-6  footer-content-section footer__contentSection'>
                  <SetInnerHTML innerHTML={this.props.footerData.JSON.ES_Footer_4} espotname='ES_Footer_4' />
                </div>
              ) : (
                ''
              )}
            </div>
            <div id='customerConnect' className='row m-t-10 m-b-30 mx-0 border-top'>
              <div
                id='connect-follow'
                className='col-3 footer-content-section footer__contentSection hide-when-international'
              >
                <section className='footer-links footer__section--footerLinks'>
                  <span className='stay_in_touch_footer'>Stay in Touch.</span>
                  <p>
                    Sign up for emails and get updates about
                    <br />
                    new products and the latest trends!
                  </p>
                  <form
                    id='emailSignUpModal'
                    data-recaptcha='false'
                    className='form-inline hide-when-international'
                    action='none'
                    method='post'
                    name='emailSignUpModal'
                    onSubmit={this.emailSignUpSubmit}
                  >
                    <div className='d-flex justify-content-center form-group emailInput m-0'>
                      <input name='storeId' type='hidden' value='301' />
                      <input name='catalogId' type='hidden' value='301' />
                      <input name='langId' type='hidden' value='-1' />
                      <label htmlFor='recipientEmail' className='sr-only'>
                        Email sign-up
                      </label>
                      <input
                        className='form-control footer__input--email'
                        id='recipientEmail'
                        maxLength='254'
                        name='recipientEmail'
                        title='Email Address'
                        data-validate='required, email'
                        type='email'
                        placeholder='enter your email address'
                        aria-describedby='emailError'
                      />
                      <button
                        role='button'
                        className='btn footerSubmit'
                        data-toggle='modal'
                        data-target=' '
                        data-modal-title=' '
                        data-modal-body='ajaxEmailSignup({"formId":"emailSignUpModal"})'
                      >
                        <i className='icon i-arrow-right'>
                          <svg
                            role='img'
                            aria-labelledby='arrowRightEmailSignUp'
                            aria-hidden='true'
                            xmlns='http://www.w3.org/2000/svg'
                            viewBox='0 0 25.39 48.77'
                          >
                            <title id='arrowRightEmailSignUp'>arrow-right</title>
                            <g data-name='Layer 2'>
                              <g data-name='Layer 1'>
                                <path d='M1,48.77a1,1,0,0,1-.71-1.71L23,24.39.29,1.71A1,1,0,0,1,1.71.29L25.09,23.68a1,1,0,0,1,0,1.41L1.71,48.48A1,1,0,0,1,1,48.77Z' />
                              </g>
                            </g>
                          </svg>
                        </i>
                        <span className='sr-only'>Submit</span>
                      </button>
                    </div>
                  </form>
                </section>
              </div>
              <div
                id='footerCareers'
                className={`${this.props.passedAppFunctions.country != 'US' ? 'careersIntl' : ''} col-3`}
              >
                <div id='footerCareersWrapper'>
                  <span className='we_are_hiring_footer'>We Are Hiring!</span>
                  <div className='careersTagline'>Join our team</div>
                  <a
                    target='blank'
                    rel='noopener'
                    className='joinOurTeamLink'
                    href='https://careers.dillards.com/Careers/'
                    role='button'
                  >
                    Click <span>HERE</span> to learn more
                  </a>
                </div>
              </div>
              <div
                id='textSignUp'
                className='col-3 footer-content-section footer__contentSection hide-when-international'
              >
                <section className='footer-links footer__section--footerLinks'>
                  <span className='be_mobile_vip_footer'>Be a Mobile VIP!</span>
                  <p>
                    Sign up for texts and be the first to know
                    <br />
                    about upcoming sales and great offers.
                  </p>
                  <form
                    id='textSignUpModal'
                    data-recaptcha='false'
                    className='form-inline hide-when-international'
                    action='none'
                    method='post'
                    name='textSignUpModal'
                  >
                    <div className='d-flex justify-content-center form-group textInput m-0'>
                      <input name='storeId' type='hidden' value='301' />
                      <input name='catalogId' type='hidden' value='301' />
                      <input name='langId' type='hidden' value='-1' />
                      <label htmlFor='recipientText' className='sr-only'>
                        Text sign-up
                      </label>
                      <input
                        className='form-control footer__input--text'
                        id='recipientText'
                        maxLength='14'
                        name='recipientText'
                        title='Phone Number'
                        data-validate='required, phone'
                        type='tel'
                        autoComplete='off'
                        placeholder='enter your mobile number'
                        aria-describedby='phoneError'
                        data-mask='(000) 000-0000'
                      />
                      <button
                        role='button'
                        className='btn textFooterSubmit'
                        data-toggle='modal'
                        data-target=' '
                        data-modal-title=' '
                        data-modal-body='ajaxTextSignup({"formId":"textSignUpModal"})'
                      >
                        <i className='icon i-arrow-right'>
                          <svg
                            role='img'
                            aria-labelledby='arrowRightTextSignUp'
                            aria-hidden='true'
                            xmlns='http://www.w3.org/2000/svg'
                            viewBox='0 0 25.39 48.77'
                          >
                            <title id='arrowRightTextSignUp'>arrow-right</title>
                            <g data-name='Layer 2'>
                              <g data-name='Layer 1'>
                                <path d='M1,48.77a1,1,0,0,1-.71-1.71L23,24.39.29,1.71A1,1,0,0,1,1.71.29L25.09,23.68a1,1,0,0,1,0,1.41L1.71,48.48A1,1,0,0,1,1,48.77Z' />
                              </g>
                            </g>
                          </svg>
                        </i>
                        <span className='sr-only'>Submit</span>
                      </button>
                    </div>
                  </form>
                </section>
              </div>
            </div>

            <div
              id='emailDisclaimerRow'
              className='email-disclaimer-footer row m-b-10 mx-0 m-l-0 m-r-0 p-l-10 p-r-10 px-4 p-l-4 p-y-4 justify-content-center'
            >
              <SetInnerHTML
                innerHTML={this.props.footerData.JSON.ES_EMAIL_DISCLAIMER_FOOTER}
                espotname={'ES_EMAIL_DISCLAIMER_FOOTER'}
              />
            </div>

            <div id='socialIconsRow' className='row m-b-10 mx-0'>
              <div id='social-icons' className='col-12 footer-content-section footer__contentSection'>
                <section className='footer-icons footer__footerIcons'>
                  <ul>
                    <li className='footer-instagram'>
                      <a
                        target='_blank'
                        rel='noopener noreferrer'
                        className='exit-link yesOL'
                        data-exitlink='Footer Instagram'
                        href='https://www.instagram.com/dillards/'
                        title='Instagram'
                      >
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          viewBox='0 0 48.9 48.9'
                          height='44'
                          width='44'
                          role='img'
                          aria-labelledby='instagramFooterIcon'
                        >
                          <title id='instagramFooterIcon'>Instagram</title>
                          <g data-name='Layer 2'>
                            <g data-name='Layer 1'>
                              <path d='M38.45,16.67a7.15,7.15,0,0,0-1-3.4,5.65,5.65,0,0,0-4.16-2.66,39.71,39.71,0,0,0-4.6-.31c-2.81,0-5.63,0-8.45,0-1.38,0-2.76.09-4.13.22A6.19,6.19,0,0,0,12.56,12a5.68,5.68,0,0,0-2,3.67,42.15,42.15,0,0,0-.3,4.56c0,2.83,0,5.66,0,8.48,0,1.38.08,2.76.23,4.13a6.08,6.08,0,0,0,2,4.08,6.61,6.61,0,0,0,4.17,1.57c2.57.13,7.72.18,7.72.16,1.41,0,2.82,0,4.22,0s2.79-.07,4.17-.23a5.87,5.87,0,0,0,5.48-5.18,34.67,34.67,0,0,0,.3-4.68c0-2.68,0-5.36,0-8Q38.58,18.58,38.45,16.67Zm-14,16.66a8.87,8.87,0,1,1,8.88-8.84A8.85,8.85,0,0,1,24.42,33.34Zm9.25-16a2.07,2.07,0,1,1,0-4.13,2.07,2.07,0,0,1,0,4.13Z'></path>
                              <path d='M24.47,18.71a5.76,5.76,0,1,0,5.72,5.81A5.75,5.75,0,0,0,24.47,18.71Z'></path>
                              <path d='M24.45,0A24.45,24.45,0,1,0,48.9,24.45,24.45,24.45,0,0,0,24.45,0ZM41.61,31.6A11.91,11.91,0,0,1,40.73,36a8.81,8.81,0,0,1-6.31,5.28,16.56,16.56,0,0,1-3.91.42c-3.64,0-7.28.06-10.91,0A23.76,23.76,0,0,1,15,41.38,9.07,9.07,0,0,1,7.39,33c-.16-1.67-.21-3.36-.23-5q0-4.12,0-8.25a23.24,23.24,0,0,1,.45-5.23,8.85,8.85,0,0,1,4.55-6,10.65,10.65,0,0,1,4.39-1.17c4-.25,7.94-.16,11.91-.13,1.51,0,3,.06,4.53.22a9.12,9.12,0,0,1,6.72,3.72,9.32,9.32,0,0,1,1.74,4.77c.14,1.66.18,3.34.23,5C41.74,22.1,41.68,29.22,41.61,31.6Z'></path>
                            </g>
                          </g>
                        </svg>
                        <span className='sr-only'>Opens Dillard&apos;s Instagram in a new window</span>
                      </a>
                    </li>
                    <li className='footer-facebook'>
                      <a
                        target='_blank'
                        rel='noopener noreferrer'
                        className='exit-link yesOL'
                        data-exitlink='Footer Facebook'
                        href='https://www.facebook.com/Dillards'
                        title='Facebook'
                      >
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          viewBox='0 0 48.9 48.9'
                          height='44'
                          width='44'
                          role='img'
                          aria-labelledby='facebookFooterIcon'
                        >
                          <title id='facebookFooterIcon'>Facebook</title>
                          <g data-name='Layer 2'>
                            <g data-name='Layer 1'>
                              <polygon points='24.45 48.9 24.45 48.9 24.45 48.9 24.45 48.9'></polygon>
                              <path d='M24.45,0a24.44,24.44,0,0,0-4.26,48.51V30.61H14V23.48h6.15V18.23c0-6.1,3.73-9.42,9.17-9.42a50.58,50.58,0,0,1,5.5.28v6.37H31.09c-3,0-3.53,1.41-3.53,3.47v4.55h7.06l-.92,7.13H27.55V48.68A24.44,24.44,0,0,0,24.45,0Z'></path>
                            </g>
                          </g>
                        </svg>
                        <span className='sr-only'>Opens Dillard&apos;s Facebook in a new window</span>
                      </a>
                    </li>
                    <li className='footer-pinterest'>
                      <a
                        target='_blank'
                        rel='noopener noreferrer'
                        className='exit-link yesOL'
                        data-exitlink='Footer Pinterest'
                        href='https://www.pinterest.com/dillards/'
                        title='Pinterest'
                      >
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          viewBox='0 0 48.71 48.71'
                          height='44'
                          width='44'
                          role='img'
                          aria-labelledby='pinterestFooterIcon'
                        >
                          <title id='pinterestFooterIcon'>Pintrest</title>
                          <g data-name='Layer 2'>
                            <g data-name='Layer 1'>
                              <path d='M24.36,0a24.35,24.35,0,0,0-9.63,46.72c-.94-8.49,2-15,3.38-21.87-2.46-4.13.3-12.46,5.48-10.41C30,17,18.06,29.82,26,31.43,34.39,33.11,37.79,17,32.62,11.71c-7.47-7.58-21.75-.18-20,10.68.43,2.65,3.17,3.46,1.1,7.12-4.78-1.06-6.21-4.83-6-9.86.29-8.23,7.39-14,14.51-14.79,9-1,17.46,3.31,18.62,11.78,1.31,9.55-4.06,19.91-13.69,19.17-2.61-.2-3.7-1.49-5.75-2.74C20.33,38.63,19,43.94,15.47,47A24.35,24.35,0,1,0,24.36,0Z'></path>
                            </g>
                          </g>
                        </svg>
                        <span className='sr-only'>Opens Dillard&apos;s Pinterest in a new window</span>
                      </a>
                    </li>
                    <li className='footer-twitter'>
                      <a
                        target='_blank'
                        rel='noopener noreferrer'
                        className='exit-link yesOL'
                        data-exitlink='Footer Twitter'
                        href='https://twitter.com/Dillards'
                        title='Twitter'
                      >
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          viewBox='0 0 48.9 48.9'
                          height='44'
                          width='44'
                          role='img'
                          aria-labelledby='twitterFooterIcon'
                        >
                          <title id='twitterFooterIcon'>Twitter/X</title>
                          <g data-name='Layer 2'>
                            <g data-name='Layer 1'>
                              <polygon points='16.4,11.7 13.2,11.7 32.6,37.1 35.6,37.1 	' />
                              <path
                                d='M24.5,0C10.9,0,0,10.9,0,24.4s10.9,24.5,24.5,24.5S48.9,38,48.9,24.4S38,0,24.5,0z M31.1,40.3l-8.5-11.1
																L13,40.3H7.6l12.5-14.3L7,8.6H18l7.6,10.1l8.8-10.1h5.4L28.2,22L42,40.3H31.1z'
                              />
                            </g>
                          </g>
                        </svg>
                        <span className='sr-only'>Opens Dillard&apos;s Twitter/X in a new window</span>
                      </a>
                    </li>
                    <li className='footer-youtube'>
                      <a
                        target='_blank'
                        rel='noopener noreferrer'
                        className='exit-link yesOL'
                        data-exitlink='Footer YouTube'
                        href='https://www.youtube.com/user/Dillards'
                        title='YouTube'
                      >
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          viewBox='0 0 48.76 48.76'
                          height='44'
                          width='44'
                          role='img'
                          aria-labelledby='youtubeFooterIcon'
                        >
                          <title id='youtubeFooterIcon'>YouTube</title>
                          <g data-name='Layer 2'>
                            <g data-name='Layer 1'>
                              <polygon points='20.99 29.79 29.78 24.38 20.99 18.96 20.99 29.79'></polygon>
                              <path d='M24.38,0A24.38,24.38,0,1,0,48.76,24.38,24.38,24.38,0,0,0,24.38,0ZM41.26,32.77a4.75,4.75,0,0,1-3.33,3.13c-2.75.72-13.56.67-13.56.67s-10.81.07-13.56-.67a4.86,4.86,0,0,1-3.38-3.13c-.74-2.73-.67-8.39-.67-8.39s-.07-5.66.67-8.39a4.81,4.81,0,0,1,3.38-3.13c2.75-.72,13.56-.67,13.56-.67s11,0,13.76.72A4.38,4.38,0,0,1,41.24,16,45.52,45.52,0,0,1,42,24.38S42,30.06,41.26,32.77Z'></path>
                            </g>
                          </g>
                        </svg>
                        <span className='sr-only'>Opens Dillard&apos;s YouTube in a new window</span>
                      </a>
                    </li>
                    <li className='footer-tiktok'>
                      <a
                        target='_blank'
                        rel='noopener noreferrer'
                        className='exit-link yesOL'
                        data-exitlink='Footer TikTok'
                        href='https://www.tiktok.com/@dillards'
                        title='TikTok'
                      >
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          viewBox='0 0 48.9 48.9'
                          height='44'
                          width='44'
                          role='img'
                          aria-labelledby='tiktokFooterIcon'
                        >
                          <title id='tiktokFooterIcon'>TikTok</title>
                          <g data-name='Layer 2'>
                            <g data-name='Layer 1'>
                              <path
                                d='M24.5,0C10.9,0,0,10.9,0,24.5C0,38,10.9,48.9,24.5,48.9C38,48.9,48.9,38,48.9,24.5C48.9,10.9,38,0,24.5,0z
																M39.4,21.4c-3,0-5.9-1-8.2-2.6v11.9c0,6-4.9,10.8-10.8,10.8c-2.3,0-4.4-0.7-6.2-2c-2.8-2-4.6-5.2-4.6-8.9c0-6,4.9-10.8,10.8-10.8
															   c0.5,0,1,0,1.5,0.1v6c-0.5-0.1-0.9-0.2-1.5-0.2c-2.7,0-4.9,2.2-4.9,4.9c0,1.9,1.1,3.5,2.7,4.4c0.7,0.4,1.5,0.6,2.3,0.6
															   c2.7,0,4.8-2.1,4.9-4.8l0-23.6h5.9c0,0.5,0.1,1,0.1,1.5c0.4,2.2,1.7,4.2,3.6,5.4c1.3,0.8,2.8,1.3,4.5,1.3V21.4z'
                              />
                            </g>
                          </g>
                        </svg>
                        <span className='sr-only'>Opens Dillard&apos;s TikTok in a new window</span>
                      </a>
                    </li>
                    <li className='footer-snapchat'>
                      <a
                        target='_blank'
                        rel='noopener noreferrer'
                        className='exit-link yesOL'
                        data-exitlink='Footer Snapchat'
                        href='https://www.snapchat.com/add/dillardssnaps'
                        title='Snapchat'
                      >
                        <svg
                          viewBox='0 0 44 44'
                          xmlns='http://www.w3.org/2000/svg'
                          width='44'
                          height='44'
                          role='img'
                          aria-labelledby='snapchatFooterIcon'
                        >
                          <title id='snapchatFooterIcon'>Snapchat</title>
                          <path
                            fillRule='evenodd'
                            clipRule='evenodd'
                            d='M22 44C34.1503 44 44 34.1503 44 22C44 9.84973 34.1503 0 22 0C9.84973 0 0 9.84973 0 22C0 34.1503 9.84973 44 22 44ZM30.7192 23.2952C30.757 23.5903 31.6056 27.5695 36.9296 30.1467C37.2413 30.2979 37.7719 30.6176 36.8381 31.1279C36.0334 31.5724 35.3765 31.7474 34.822 31.8951C34.3639 32.0171 33.9757 32.1205 33.632 32.3418C33.2833 32.5665 33.2344 32.9316 33.189 33.2708C33.1504 33.5588 33.1144 33.8281 32.8994 33.9766C32.6493 34.149 32.187 34.1667 31.5646 34.1906C30.751 34.2217 29.6638 34.2633 28.4196 34.6749C27.811 34.8763 27.2769 35.2047 26.7118 35.552C25.594 36.2389 24.3557 37 22.183 37C20.0187 37 18.7957 36.2483 17.6816 35.5635C17.1118 35.2133 16.5704 34.8806 15.9463 34.6749C14.6996 34.2633 13.6127 34.2217 12.7997 34.1906C12.1777 34.1667 11.7162 34.149 11.4664 33.9766C11.251 33.828 11.215 33.5586 11.1764 33.2704C11.1311 32.9314 11.0824 32.5664 10.7339 32.3418C10.3901 32.1205 10.002 32.0171 9.54382 31.8951C8.98914 31.7474 8.33203 31.5724 7.52771 31.1279C6.59216 30.6115 7.1228 30.2916 7.43457 30.1406C12.7577 27.5677 13.6072 23.5886 13.6449 23.2891C13.6906 22.9315 13.7416 22.6505 13.348 22.2867C13.0894 22.0472 12.226 21.4879 11.5529 21.0518C11.2363 20.8466 10.9618 20.6687 10.812 20.5642C10.0355 20.0232 9.69653 19.4829 9.94775 18.8188C10.1234 18.3621 10.5494 18.1864 11.0018 18.1864C11.074 18.1864 11.1459 18.1907 11.2174 18.1989C11.2869 18.2069 11.356 18.2188 11.4243 18.2339C11.926 18.3428 12.4193 18.5358 12.8374 18.6993C13.1277 18.8129 13.3818 18.9122 13.5773 18.9595C13.6344 18.9744 13.6941 18.9823 13.7529 18.9832C14.0077 18.9832 14.0973 18.8549 14.0797 18.5632L14.0652 18.3207C14.0059 17.3405 13.9053 15.683 14.0402 14.1256C14.2396 11.7943 14.9906 10.6392 15.8848 9.61768C16.3135 9.12842 18.3136 7 22.1786 7C26.0435 7 28.0463 9.12842 28.4775 9.62378C29.3691 10.6454 30.1211 11.8004 30.3221 14.1317C30.4637 15.7667 30.351 17.5129 30.2892 18.4684L30.2827 18.5695C30.2581 18.876 30.3547 18.9893 30.6094 18.9893C30.6683 18.9884 30.728 18.9805 30.7852 18.9656C31.2629 18.8505 32.0886 18.4244 32.939 18.24C33.0778 18.2092 33.2191 18.1926 33.3615 18.1926C33.8121 18.1926 34.2399 18.3656 34.4155 18.8251C34.6667 19.4891 34.3259 20.0293 33.5521 20.5704C33.4022 20.675 33.1273 20.8533 32.8103 21.0587C32.1373 21.4949 31.2747 22.0541 31.0161 22.293C30.6351 22.6443 30.6707 22.9186 30.7145 23.2589L30.7192 23.2952Z'
                          />
                        </svg>
                        <span className='sr-only'>Opens Dillard&apos;s Snapchat in a new window</span>
                      </a>
                    </li>
                  </ul>
                </section>
              </div>
            </div>
          </div>
        </div>
        <div id='footer_tippy_bottom' className='footer__tippyBottom'>
          <div className='container-fluid'>
            <div className='row mx-0'>
              <div className='col-sm-12 p-0'>
                <section className='footer-links footer__section--footerLinks'>
                  <ul>
                    <li>
                      <a data-twist='footer-sitemap' href='/c/sitemap' manual_cm_sp='customerservice-_-sitemap-_-null'>
                        Site Map
                      </a>
                    </li>
                    <li className='hide-when-international'>
                      <a
                        data-twist='footer-terms-of-use'
                        href='/c/faqs-notices-policies?#q=NOTICES'
                        manual_cm_sp='customerservice-_-terms+of+use-_-null'
                      >
                        Terms Of Use
                      </a>
                    </li>
                    <li className='show-when-international'>
                      <a
                        data-twist='footer-terms-of-use'
                        href='/c/faqs-notices-policies?#q=int-policies-notices-question-legal-terms-of-use'
                        manual_cm_sp='customerservice-_-terms+of+use-_-null'
                      >
                        Terms Of Use
                      </a>
                    </li>
                    <li className='hide-when-international'>
                      <a
                        data-twist='privacy-policy'
                        href='/privacy'
                        manual_cm_sp='customerservice-_-privacy+policy-_-null'
                      >
                        Dillard&apos;s Privacy Policy
                      </a>
                    </li>
                    <li className='show-when-international'>
                      <a
                        data-twist='privacy-policy'
                        href='/privacy'
                        manual_cm_sp='customerservice-_-privacy+policy-_-null'
                      >
                        Dillard&apos;s Privacy Policy
                      </a>
                    </li>
                    <li className='hide-when-international'>
                      <a
                        data-twist='footer-california'
                        href='/c/faqs-notices-policies?#q=policies-notices-question-california'
                        manual_cm_sp='customerservice-_-CATransparencyAct-_-null '
                      >
                        California Transparency in Supply Chains Act
                      </a>
                    </li>
                    <li className='show-when-international'>
                      <a
                        data-twist='footer-california'
                        href='/c/faqs-notices-policies?#q=int-policies-notices-question-california'
                        manual_cm_sp='customerservice-_-CATransparencyAct-_-null '
                      >
                        California Transparency in Supply Chains Act
                      </a>
                    </li>
                    <li>
                      <a
                        target='_blank'
                        rel='noopener noreferrer'
                        className='exit-link yesOL'
                        data-exitlink='Footer Careers'
                        href='https://careers.dillards.com/Careers/'
                      >
                        Careers
                      </a>
                    </li>
                    <li>
                      <a
                        target='_blank'
                        rel='noopener noreferrer'
                        className='exit-link yesOL'
                        data-exitlink='Footer Investor Relations'
                        href='https://investor.dillards.com/overview/default.aspx'
                      >
                        Investor Relations
                      </a>
                    </li>
                    <li>
                      <a
                        data-twist='footer-about-us'
                        href='/c/about-dillards-company-history'
                        manual_cm_sp='customerservice-_-about+us-_-null'
                      >
                        About Us
                      </a>
                    </li>
                    <li>
                      <button
                        className='btn-tertiary'
                        data-twist='footer-cookie-settings'
                        id='footer_cookie_settings'
                        type='button'
                        onClick={this.cookieSettingsClick}
                      >
                        Your Privacy Choices
                      </button>
                      <PrivacyOptions width='22px' height='22px' />
                    </li>
                  </ul>
                </section>
                <p>
                  Prices and sale offers may vary by store location, including Dillards.com, and are subject to change.
                  &copy; {new Date().getFullYear()} Dillard&apos;s
                </p>
                <QMSessionID />
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
  updateFlagIcon() {
    if (this.props.passedAppFunctions.country != 'US') {
      var flagImageLoc = '/assets/img/flags/' + this.props.passedAppFunctions.country + '.gif';
      if ($('#flag-icon-footer-image').length == 0) {
        $('#footer-flag-img-span').prepend(
          '<img id="flag-icon-footer-image" class="flag-intl" src=' +
            flagImageLoc +
            ' alt=' +
            this.props.passedAppFunctions.country +
            '></img>'
        );
      } else {
        $('#footer-flag-img-span img').attr('src', flagImageLoc);
      }
      if ($('#flag-icon-mobile-image').length == 0) {
        $('#flag-icon-mobile-span').prepend(
          '<img id="flag-icon-mobile-image" class="flag-intl-mobile" src=' +
            flagImageLoc +
            ' alt=' +
            this.props.passedAppFunctions.country +
            '></img>'
        );
      } else {
        $('#flag-icon-mobile-span img').attr('src', flagImageLoc);
      }
    } else {
      $('#footer-flag-img-span img').remove();
      $('#flag-icon-mobile-span img').remove();
    }
  }
  componentDidUpdate() {
    this.updateFlagIcon();
  }

  componentDidMount() {
    this.updateFlagIcon();
  }
}

export default FooterContainer;
